var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"cube-drawer-item border-bottom-1px",class:_vm.itemClass,on:{"click":function($event){return _vm.clickItem(_vm.item)}}},[_vm._t("default",[_vm._v("\n    "+_vm._s(_vm.item.text || _vm.item)+"\n  ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }